import getInitials from './getInitials';
export default getInitials;
